<template>
  <div>
    <br/>
    <h5 class="pageTitle" style="text-align:center">Avicourse hivernale</h5>
    <div id="image_F1">
      <img src="/images/avicourse/avicourse1.png" alt=""/>
    </div>

    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>Bienvenue sur la page de l'Avicourse hivernale pour la grande région du COQ.</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    
    <p><strong>Tous les membres, débutants ou experts, sont invités à participer à cette activités.</strong></p>
<p>
      L'Avicourse traditionnelle existe depuis 1995, grâce à la bonne idée de Jacques Lachance, et elle se poursuit avec Maurice Raymond, comme responsable depuis 2012.
    </p>
    <p>
      La raison d'être de cette compétition amicale est de nous motiver à sortir
      pour aller observer les oiseaux durant la saison de l'hiver. L'Avicourse hivernale
      consiste à recenser le maximum d'espèces d'oiseaux durant la période que
      dure la compétition.
    </p>
    
    <p>
      Elle permet aussi aux autres membres du club non inscrits à l'activité d'aller
      voir des oiseaux rares en hiver, car toutes et tous ont accès à
      l'information via divers sites Internet. De plus, le partage d'information
      est essentiel, afin d'aider les nouveaux observateurs et résidents à mieux
      connaître la <a href="/documents/territoire_coq_2012.jpg"> grande région ornithologique du COQ</a>.
    </p>

    <div id="image_trophee">
      <ul class="enlarge">
        <li>
          <img src="/images/avicourse/trophee_avicourse_p.jpg" alt=""/>
          <!--petite image-->
          <span>
            <!--span contient la grande image popup -->
            <img src="/images/avicourse/trophee_avicourse.jpg" alt=""/>
            <!--popup image-->
            <br/>Trophée de l'Avicourse 
            <!--caption sous l'image popup-->
          </span>
        </li>
      </ul>
    </div>

    <p>
      La clôture de l'Avicourse, qui comprend la remise du trophée, se fait lors du
      Social ornitho (5 à 7) le premier ou le deuxième mercredi de mars. Le ou les gagnants de cette activité gardent
      précieusement le trophée pendant l'année qui suit.
    </p>
    <p>Rejoignez le <a href="https://www.facebook.com/groups/267285450062325" target="_blank">groupe Facebook</a> pour suivre ce défi.</p>
    <br style="clear: right"/>
    <!-- Empêche le texte qui suit de wrapper l'image -->

    <h2 class="pageSubtitle2">Règlements</h2>
    <ul>
      <li>Être membre du Club des ornithologues de Québec.</li>
      <li>
        Les participants doivent s'inscrire au début de la saison auprès du responsable, <a
          href="mailto:maurice_raymond@hotmail.com?Subject=Inscription%20à%20l'avicourse">Maurice Raymond</a>, ou par téléphone au 418 661-4043.
      </li>
      <li>
        Seules les observations faites sur le territoire du COQ sont valides.
        L'oiseau doit être sur le territoire du COQ.
      </li>
      <li>
        L'Avicourse hivernale commence le 1<sup>er</sup> décembre pour se terminer le 28&nbsp;février à
        minuit (ou le 29&nbsp;février à minuit pour les années bissextiles).
      </li>
      <li>Les participants doivent transmettre leur liste d'oiseaux observés à chaque dimanche avant 20&nbsp;h, à <a
          href="mailto:maurice_raymond@hotmail.com?Subject=Inscription%20à%20l'avicourse">Maurice Raymond</a>. La liste globale est disponible dans le
        groupe Facebook vers 20&nbsp;h, ce même dimanche.
      </li>
      <li>
        Les participants établissent leur propre liste sur le site de
        <a href="http://ebird.org/content/qc/" target="_blank">eBird</a> en
        énumérant les espèces au fur et à mesure qu'elles sont observées.
      </li>
      <li>
        Les participants s'engagent à partager leurs observations sans délais,
        (sauf dans le cas des mentions trouvées en propriété privée dont le
        propriétaire désire ne pas rendre publique l'information). D'autres
        moyens de communication sont disponibles, dont
        <a href="https://discord.com/invite/Dz2VBPe3r8" target="_blank"
        >Discord (Birding Québec)</a
        >
        ou la
        <a
            href="https://oiseauxrares.qc.ca/index.php/fr/"
            target="_blank"
        >
          Page des oiseaux rares</a
        >.
      </li>
      <li>Le COQ encourage les participants à remplir leurs feuillets
        d'observations sous
        <a href="http://ebird.org/content/qc/" target="_blank"
        >format électronique (eBird)</a
        >.
      </li>
    </ul>
    <br>

    <!-- <b-row style="margin-top: 20px; margin-bottom: 40px;">
      <b-col>
        <template v-if="activity && isConnected && activity.acceptRegistrations === true">
          <b-button

              variant="primary"
              @click="showRegisterModal"
              style="width: 100%"
          >
            Inscription à l'activité
          </b-button>
        </template>
        <template v-else-if="!activity || activity.acceptRegistrations === false">
          <b-button  variant="outline-secondary" style="width: 100%">
            Les inscriptions ne sont pas encore activés
          </b-button>
        </template>
        <template v-else>
          <b-button  variant="outline-secondary" style="width: 100%">
            Vous devez être connecté pour vous inscrire à cette activité
          </b-button>
        </template>
      </b-col>
    </b-row> -->

    <h2 class="pageSubtitle2">Document</h2>

    <table style="width: 100%" id="table_listes">

      <tr>
        <td>
          <a href="/documents/avicourse/AvicourseEspeces.pdf">
            <img src="/images/icone_pdf.png" alt=""/>
          </a>
        </td>
        <td>
          <a href="/documents/avicourse/AvicourseEspeces.pdf">
            Liste des espèces depuis 1995
          </a>
        </td>
      </tr>
      <tr>
        <td>
          <a href="/documents/avicourse/Avicourse-Participants.pdf">
            <img src="/images/icone_pdf.png" alt=""/>
          </a>
        </td>
        <td>
          <a href="/documents/avicourse/Avicourse-Participants.pdf">
            Liste des participants depuis 1995
          </a>
        </td>
      </tr>
    </table>

    <br/>
    <h2 class="pageSubtitle2">Comptes rendus</h2>
    <br/>

    <ul>
    <li><a href="/documents/avicourse/rapp-avicourse-23-24.pdf" target="_blank">Compte-rendu 2024</a><br><br></li>
    <li><a href="/documents/avicourse/rapp-avicourse-22-23.pdf" target="_blank">Compte-rendu 2023</a>; <a href="/documents/avicourse/Avicourse-SE-22-23.pdf" target="_blank">Avicourse zéro voiture 2022-2023</a><br><br></li>
      <li><a href="/documents/avicourse/rapp-avicourse-21-22.pdf" target="_blank">Compte-rendu 2022</a>; <a href="/documents/avicourse/Avicourse-SE-21-22.pdf" target="_blank">Avicourse zéro voiture 2021-2022</a></li>
      <li v-for="year in years" :key="year">
        <p>
          <router-link :to="{ name: 'AvicourseSinglePage', params: { year } }">Compte rendu {{ year }}</router-link>

          <template v-if="year === 2021">
            &nbsp;|&nbsp;<a href="/documents/avicourse/Avicourse-SE-20-21.pdf" target="_blank">Avicourse zéro voiture 2020-2021</a>
          </template>

        </p>
      </li>
    </ul>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ActivityRegistrationModal from '../../components/Activites/Activite_Inscription';
  import _ from 'lodash';

  export default {
    name: 'Avicourse',
    data() {
      return {
        years: [ 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001, 2000, 1999, 1998, 1997, 1996, 1995 ]
      };
    },
    async mounted() {
      await this.fetchActivities();
    },
    computed: {
      ...mapGetters('services', {
        _activities: 'activities'
      }),
      ...mapGetters({
        isConnected: 'account/isConnected'
      }),
      activity() {
        // Return the enabled avicourse
        let activities = this._activities;
        if (!activities) {
          return activities;
        }
        activities = _.sortBy(activities, a => a.date);
        if (_.isNumber(this.limit)) {
          activities = _.slice(activities, 0, this.limit);
        }
        return _.find(activities, a => a.type === 'avicourse' && a.acceptRegistrations === true);
      }
    },
    methods: {
      ...mapActions('services', {
        fetchActivities: 'fetchServices'
      }),
      async showRegisterModal() {
        // Ask the user to confirm and select the member to be registered.
        await this.$store.dispatch('members/fetchMembers');
        // Show modal
        this.$modal.show(
          ActivityRegistrationModal,
          {
            activityId: this.activity.id
          },
          {
            height: 'auto',
            minHeight: 300,
            name: 'activity-registration-modal',
            root: this.$root
          }
        );
      }
    }
  };
</script>

<style scoped>
a {
  font-size: 12px !important;
}

#image_F1 {
  float: left;
  padding: 5px 20px 0px 10px;
}

#image_trophee {
  float: right;
  padding: 5px 0px 0px 10px;
}

#table_listes {
  margin-left: 20px;
}

#table_listes td {
  vertical-align: middle;
  padding-bottom: 5px;
}

/* Formatage des images agrandies en mode « Popup » */
/* Code source : http://cssdemos.tupence.co.uk/image-popup.htm */

/* Style the unordered list with the class 'enlarge '*/

ul.enlarge {
  list-style-type: none; /*remove the bullet point*/
}

ul.enlarge li {
  display: inline-block; /*places the images in a line*/
  position: relative; /*allows precise positioning of the popup image when used with position:absolute - see support section */
  z-index: 0; /*resets the stack order of the list items - we'll increase in step 4. See support section for more info*/
  margin: 0px 20px 0px 20px; /*space between the images*/
}

/***In the HTML in step one we placed the large image inside a 'span' tag, now we move it off the page until it's required***/
ul.enlarge span {
  position: absolute; /*see support section for more info on positioning*/
  left: -9999px; /*moves the span off the page, effectively hidding it from view*/
}

/***Note: This styling will apply to both the thumbnail and popup image, unless you override these styles in step five***/

ul.enlarge img {
  /*give the thumbnails a frame*/
  background-color: #eae9d4; /*frame colour*/
  padding: 6px; /*frame size*/
  /*add a drop shadow to the frame*/
  -webkit-box-shadow: 0 0 6px rgba(132, 132, 132, .75);
  -moz-box-shadow: 0 0 6px rgba(132, 132, 132, .75);
  box-shadow: 0 0 6px rgba(132, 132, 132, .75);
  /*and give the corners a small curve*/
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

ul.enlarge li:hover {
  z-index: 50; /*places the popups infront of the thumbnails, which we gave a z-index of 0 in step 1*/
  cursor: pointer; /*changes the cursor to a hand*/
}

/***We bring the large image back onto the page by reducing left from -9999px (set in step 2) to figures below***/
ul.enlarge li:hover span { /*positions the 'span' tag when the 'li' tag (which contains the thumbnail) is hovered*/
  top: -200px; /*the distance from the bottom of the thumbnail to the top of the popup image*/
  left: -700px; /*distance from the left of the thumbnail to the left of the popup image*/
}

/***To make it look neater we used :nth-child to set a different left distance for each image***/
/*

ul.enlarge li:hover:nth-child(2) span {
    left: -100px;
}

ul.enlarge li:hover:nth-child(3) span {
    left: -200px;
}
*/
/***Override the styling of images set in step 3 to make the frame smaller and the background darker***/
ul.enlarge span img {
  padding: 2px; /*size of the frame*/
  background: #ccc; /*colour of the frame*/
}

/***Style the 'span' tag containing the framed images and the caption***/
ul.enlarge span {
  /**Style the frame**/
  padding: 10px; /*size of the frame*/
  background: #eae9d4; /*colour of the frame*/
  /*add a drop shadow to the frame*/
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .75));
  -moz-box-shadow: 0 0 20px rgba(0, 0, 0, .75);
  box-shadow: 0 0 20px rgba(0, 0, 0, .75);
  /*give the corners a curve*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  /**Style the caption**/
  font-family: Verdana, Arial, Helvetica, sans-serif;
  font-size: 1.5em;
  text-align: center;
  color: #E08934; /*#495a62*/
}

p {
  margin-left: 0 !important;
}

li {
  margin-bottom: 0 !important;
}
</style>
